<template>
  <v-content>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12">
          <DataTable
            @editing="editing"
            @deleting="deleting"
            :title="title"
            :headers="headers"
            :items="equipments"
            :search="search"
          />
        </v-col>
        <Dialogbox
          @closing="closing"
          @deleteuser="deleteEquipment"
          :title="dialogboxtitle"
          :dialog="dialogstatus"
          :buttonTitle="dialogButtontitle"
          :deleteuser="true"
          v-if="dialogstatus"
        />
      </v-row>
    </v-container>
    <v-btn dark fab fixed bottom right large color="pink" class="mx-2" @click="addEquipment">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </v-content>
</template>

<script>
import { mapGetters } from "vuex"
import store from "@/store"
import {
  FETCH_EQUIPMENTS,
  DELETE_EQUIPMENT,
  RESET_STATE
} from "@/store/actions.type";
import { SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"
export default {
  name: "Users",
  beforeRouteEnter(to, from, next) {
    store.dispatch(RESET_STATE)
    store.dispatch(FETCH_EQUIPMENTS, "").then(resp => {
      if (resp.success) {
        store.commit(SET_LOADING, false)
        store.commit(SET_ROUTER_ENTER, false)
      }
    });
    return next();
  },
  async beforeRouteLeave(to, from, next) {
    await store.dispatch(RESET_STATE)
    next();
  },
  created(){
    if(this.currentUser.roles.includes(1) ==false && this.currentUser.roles.includes(3)== false && JSON.parse(this.currentUser.company.company_meta).has_equip_db == "false"){
      this.$router.push('/learningcenter');
    }
  },
  data: function() {
    return {
      title: "Equipment",
      search: "",
      dialogstatus: false,
      dialogButtontitle: null,
      dialogboxtitle: null,
      equipmentid: null,
      singleSelect: "",
      dialog: false,
    };
  },
  components: {
    DataTable: () => import("@/components/datatable/datatable"),
    Dialogbox: () => import("@/components/dialog/dialog")
  },
  computed: {
    ...mapGetters(["equipments", 'currentUser']),
    headers(){
      return [
        { text: this.$t("Location"), value: "location" },
        { text: this.$t("Procedure"), value: "procedure" },
        { text: this.$t("Class"), value: "class" },
        { text: this.$t("Maker"), value: "maker" },
        { text: this.$t("Status"), value: "status" },
        { text: this.$t("Serial maker"), value: "serial_number" },
        { text: this.$t("Stock"), value: "num_in_stock" }, 
        { text: this.$t("Good until date"), value: "good_until" },         
        { text: this.$t("Actions"), value: "action", sortable: false }
      ]
    }
  },
  methods: {
    addEquipment() {
      this.$router.push("/equipment/add");
    },
    editing(id) {
      this.$router.push("/equipment/edit/" + id)
    },
    deleting(id) {
      this.dialogstatus = true
      this.dialogboxtitle = "Are you sure want to remove?"
      this.dialogButtontitle = "Remove"
      this.equipmentid = id
    },
    async deleteEquipment() {
      await this.$store
        .dispatch(DELETE_EQUIPMENT, this.equipmentid)
        .then(async resp => {
          if (resp.success) {
            this.equipmentid = null;
            await store.dispatch(FETCH_EQUIPMENTS, "").then(resp => {
              if (resp.success) {
                store.commit(SET_LOADING, false);
                this.dialogstatus = false;
              }
            });
          }
        });
    },
    closing() {
      this.dialogstatus = false
    },
  }
};
</script>